import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      hasError: this.state.hasError,
      errorInfo: error,
    });
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ? this.props.fallback : <body1>There has been an issue</body1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
